export default __webpack_public_path__ + "static/media/morty-smith.d025a5c7.jpg";